import React from 'react';
import localDoCulto from "./txt/localDoCulto.json"
import { MapPin, Mail, Instagram, Youtube } from 'lucide-react';
import Carousel from './components/Carousel';
import Fotos from './json/fotos.json'
import NavLink from './components/NavLink';
import DiaCulto from './components/DiaCulto';
import diasCulto from './json/dias-culto.json';
import duvidasVisitante from './json/duvidas-visitante.json';

// Main App component
const App = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-700 via-blue-800 to-blue-900 text-white font-inter">
      {/* Navigation Bar */}
      <nav className="fixed top-0 left-0 w-full bg-blue-950 bg-opacity-95 shadow z-50">
        <div className="container mx-auto flex flex-wrap items-center justify-center py-3 gap-4">
          <NavLink href="#welcome">Bem-vindo</NavLink>
          <NavLink href="#history" >História</NavLink>
          <NavLink href="#schedule" >Horários</NavLink>
          <NavLink href="#location">Localização</NavLink>
          <NavLink href="#contact">Contato</NavLink>
          <NavLink href="#activities">Atividades</NavLink>
          <NavLink href="#visitors">Visitantes</NavLink>
          <NavLink href="#gallery">Fotos e Vídeos</NavLink>

        </div>
      </nav>

      {/* Header Section */}
      <header className="mt-2 py-12 text-center bg-blue-950 shadow-lg">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-4 animate-fade-in">
          IASD São Benedito
        </h1>
        <p className="text-xl md:text-2xl font-light italic opacity-90 animate-slide-up">
          Até aqui nos ajudou o SENHOR - 1Sm 1:12


        </p>
      </header>

      {/* Welcome Section */}
      <section id="welcome" className="container mx-auto px-6 py-20 text-center">
        <h2 className="text-4xl font-bold mb-8 animate-fade-in delay-200">Seja Bem-vindo(a)!</h2>
        <p className="text-lg md:text-xl leading-relaxed max-w-3xl mx-auto opacity-90 animate-fade-in delay-300">
          Somos uma comunidade vibrante, dedicada a compartilhar o amor de Jesus e a esperança que Ele nos oferece. Acreditamos na transformação de vidas através da fé, do estudo da Bíblia e do serviço ao próximo. Aqui, você encontrará um ambiente acolhedor para toda a família, onde poderá crescer espiritualmente, fazer novas amizades e descobrir um propósito maior para sua vida.
        </p>
      </section>

      {/* History & Bible Section */}
      <section id="history" className="container mx-auto px-6 py-12 text-center">
        <h2 className="text-3xl font-bold mb-4 animate-fade-in delay-350">Nossa História</h2>
        <p className="text-lg md:text-xl max-w-2xl mx-auto mb-6 animate-fade-in delay-400">
          A IASD São Benedito foi criada em 22/09/2010, fruto do sonho e dedicação de membros comprometidos em levar a mensagem de esperança a todos os moradores do bairro. Desde então, temos sido um ponto de luz, fé e serviço cristão em nossa comunidade.
        </p>
        <blockquote className="bg-blue-800 bg-opacity-80 rounded-xl shadow-lg p-6 max-w-2xl mx-auto text-lg italic border-l-4 border-blue-400 animate-fade-in delay-500">
          "E disse-lhes: Ide por todo o mundo, pregai o evangelho a toda criatura. Quem crer e for batizado será salvo; mas quem não crer será condenado. E estes sinais seguirão aos que crerem: Em meu nome expulsarão demônios; falarão novas línguas; pegarão nas serpentes; e, se beberem alguma coisa mortífera, não lhes fará dano algum; e porão as mãos sobre os enfermos, e os curarão."<br />
          <span className="block mt-2 text-blue-200 font-semibold">Marcos 16:15-18</span>
        </blockquote>
      </section>

      {/* Service Schedule Section */}
      <section id="schedule" className="bg-blue-900 py-16">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-12 animate-fade-in delay-400">Nossos Horários de Culto</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {
              diasCulto.map((e) => <DiaCulto dia={e.dia} horario={e.horario} nomedoculto={e.nomedoculto} descricao={e.descricao} />)
            }

          </div>
        </div>
      </section>

      {/* Location Section */}
      <section id="location" className="container mx-auto px-6 py-16 text-center">
        <h2 className="text-4xl font-bold mb-8 animate-fade-in delay-800">Onde Estamos?</h2>
        <div className="flex flex-col items-center justify-center animate-fade-in delay-900">
          <MapPin className="w-16 h-16 text-red-400 mb-4" />
          <div className="text-lg md:text-xl mb-4 whitespace-pre-wrap">
            {localDoCulto.Local}
          </div>
          <a
            href={localDoCulto.Link} // Replace with actual Google Maps link
            target="_blank"
            rel="noopener noreferrer"
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full shadow-lg transition-colors duration-300 flex items-center"
          >
            Ver no Google Maps
            <MapPin className="ml-2 w-5 h-5" />
          </a>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="bg-blue-900 py-16">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-8 animate-fade-in delay-1000">Entre em Contato</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="bg-blue-800 p-6 rounded-xl shadow-lg flex flex-col items-center animate-fade-in-up delay-1200">
              <Mail className="w-10 h-10 mb-3 text-blue-300" />
              <h3 className="text-2xl font-semibold mb-2">E-mail</h3>
              <a href="mailto:Iasd.saobenedito7@gmail.com" className="text-lg text-blue-200 hover:underline">
                Iasd.saobenedito7@gmail.com
              </a>
            </div>

            <div className="bg-blue-800 p-6 rounded-xl shadow-lg flex flex-col items-center animate-fade-in-up delay-1200">
              <Instagram className="w-10 h-10 mb-3 text-blue-300" />
              <h3 className="text-2xl font-semibold mb-2">Instagram</h3>

              <a href="https://www.instagram.com/iasd.saobenedito07/" className="text-lg text-blue-200 hover:underline">
                iasd.saobenedito07
              </a>
            </div>
            <div className="bg-blue-800 p-6 rounded-xl shadow-lg flex flex-col items-center animate-fade-in-up delay-1200">
              <Youtube className="w-10 h-10 mb-3 text-blue-300" />
              <h3 className="text-2xl font-semibold mb-2">YouTube</h3>

              <a href="https://www.youtube.com/@IasdSaoBenedito" className="text-lg text-blue-200 hover:underline">
                Iasd Sao Benedito
              </a>
            </div>


          </div>
        </div>
      </section>

      {/* Activities Section */}
      <section id="activities" className="container mx-auto px-6 py-12 text-center">
        <h2 className="text-3xl font-bold mb-4 animate-fade-in delay-350">Atividades da Igreja</h2>
        <div className="bg-blue-800 bg-opacity-80 rounded-xl shadow-lg p-8 max-w-2xl mx-auto animate-fade-in delay-400">
          <h3 className="text-2xl font-semibold mb-2 text-blue-200">P.G. - Os Peregrinos</h3>
          <p className="text-base mb-2 text-blue-100"><strong>Data de início:</strong> 07/06/2024</p>
          <p className="text-lg mb-4">
            A origem do grupo foi formada pela iniciativa do pastor. A motivação foi para que mais pessoas fossem alcançadas fora de uma igreja. O propósito é evangelístico.
          </p>
          <p className="text-lg mb-4">
            Todas as sextas-feiras há o pequeno grupo, começando às 19h. O local de encontro é na casa da nossa irmã Hilda.
          </p>
          <p className="text-lg mb-4">
            No P.G. há oração inicial, louvores, pedidos de oração, estudo da lição do pequeno grupo e depois a oração final. Além disso, sempre tem um lanchinho para todos após o encerramento. Boas conversas e novos laços de amizade são criados.
          </p>
        </div>
      </section>

      {/* Visitor Section */}
      <section id="visitors" className="container mx-auto px-6 py-12 text-center">
        <h2 className="text-3xl font-bold mb-8 animate-fade-in delay-350">Informações para Visitantes</h2>
        <div className="bg-blue-800 bg-opacity-80 rounded-xl shadow-lg p-8 max-w-3xl mx-auto text-left animate-fade-in delay-400">
          <ol className="list-decimal list-inside space-y-6">
            {
              duvidasVisitante.map((e) => {
                return <li>
                  <strong>{e.p}</strong>
                  <p className="mt-2 text-lg">
                    {e.r}
                  </p>
                </li>
              })
            }
          </ol>
        </div>
      </section>

      {/* Gallery Section */}
      <section id="gallery" className="container mx-auto px-6 py-12 text-center">
        <h2 className="text-3xl font-bold mb-8 animate-fade-in delay-350">Fotos & Vídeos</h2>
        <Carousel images={Fotos} />
        <div className="flex justify-center mt-8">
          {/* Exemplo de vídeo do YouTube - substitua o link pelo vídeo desejado */}
          <iframe
            className="rounded-xl shadow-lg w-full max-w-2xl h-64 md:h-96"
            src="https://www.youtube.com/embed/aRlBHKh4iKo"
            title="Vídeo da Igreja"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 text-center bg-blue-950 text-gray-400 text-sm">
        <p>&copy; {new Date().getFullYear()} IASD São Benedito. Todos os direitos reservados.</p>
        <p className="mt-2">Visite-nos e encontre a esperança!</p>
      </footer>
    </div>
  );
};

export default App;
